import { Card, CardContent, Chip, Grid } from '@mui/material';
import { Icon, Typography } from '@zenput/legacy-ui-components';
import Linkify from 'linkify-react';
import { makeStyles } from 'tss-react/mui';
import unescape from 'lodash/unescape';

const { Body, Caption } = Typography;

const useStyles = makeStyles()({
    carouselItem: {
        maxHeight: 140,
        margin: 8,
        overflow: 'visible !important'
    },
    labelGrid: {
        textAlign: 'left'
    },
    iconWrapper: {
        height: 22,
        width: 22,
        padding: 2,
        backgroundColor: '#08A2E3',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    countGrid: {
        textAlign: 'right'
    },
    label: {
        backgroundColor: '#B9E2F4'
    },
    title: {
        fontWeight: 400
    }
});

const Banner = (props) => {
    const { count, index, label, message, title, type, handleBannerDetailsClick } = props;
    const { classes } = useStyles();

    // for future support of other message types
    const iconVariant = type === 'announcement' ? 'df-announcement' : 'df-comment';

    const position = index + 1;

    return (
        <Card className={classes.carouselItem}>
            <CardContent>
                <Grid container alignItems="center" justifyContent="space-between" spacing={1}>
                    <Grid item xs className={classes.labelGrid}>
                        {label && <Chip className={classes.label} label={label} size="small" />}
                    </Grid>
                    <Grid item>
                        <div className={classes.iconWrapper}>
                            <Icon variant={iconVariant} className="icon" color="#FFFFFF" size={12} />
                        </div>
                    </Grid>
                    <Grid className={classes.countGrid} item xs>
                        <Chip label={`${position}/${count}`} size="small" />
                    </Grid>
                </Grid>
                <Grid container justifyContent="center" align="center" direction="row">
                    <Grid item xs={10}>
                        <div>
                            <Body className={classes.title} noWrap>
                                {title}
                            </Body>
                        </div>
                    </Grid>
                </Grid>
                <Grid container justifyContent="center" align="center">
                    <Grid item xs={10}>
                        <Caption display="block" noWrap>
                            <Linkify as="span">{unescape(message)}</Linkify>
                        </Caption>
                    </Grid>
                </Grid>
                <Grid container justifyContent="center" align="center">
                    <Grid item xs={10}>
                        <Body bold>
                            <a href="#" onClick={() => handleBannerDetailsClick(index)}>
                                {_t('mobile_announcement_banner_continue_reading')}
                            </a>
                        </Body>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default Banner;
